document.addEventListener('DOMContentLoaded', function() {
  const thumbnails = document.querySelectorAll(".product-thumbnails__item-link");
  
  thumbnails.forEach(thumbnail => {
    thumbnail.addEventListener("click", function() {
      const thumbnailId = this.getAttribute("data-thumbnail-id");
      const mediaItems = document.querySelectorAll(".product__media-item");
  
      mediaItems.forEach(mediaItem => {
        mediaItem.classList.add("hidden");
        if (mediaItem.getAttribute("data-media-item-id") === thumbnailId) {
          mediaItem.classList.remove("hidden");
        }
      });
  
      thumbnails.forEach(thumbnail => {
        thumbnail.classList.remove("active");
      });
      this.classList.add("active");
    });
  });
  
  var swiper = new Swiper(".product__block-featured-products .carousel", {
    slidesPerView: 2.2,
    spaceBetween: 12,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    breakpoints: {
      768: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 30,
      },
    },
  });
  
  var swiperproduct = new Swiper(".product__media-container.carousel", {
    slidesPerView: 1,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    }
  });

  // accordion js
  const accordionItems = document.querySelectorAll('.accordion');
  accordionItems.forEach(item => {
    const button = item.querySelector('.accordion__label');
    const content = item.querySelector('.accordion__content');
    button.addEventListener('click', function() {
      const isOpen = item.getAttribute('data-open') === 'true';
      item.setAttribute('data-open', String(!isOpen));
      content.style.display = isOpen ? 'none' : 'block';
      button.setAttribute('aria-expanded', String(!isOpen));
    });
  });
});